export default __webpack_public_path__ + "static/media/Daisy 9781408336519.5eb9cb39.jpg";